import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import { t } from "../services";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function FullScreenDialog(props) {
  return (
    <div>
      <Dialog
        fullScreen
        open={props.open}
        onClose={props.close}
        TransitionComponent={Transition}
      >
        <AppBar position="relative">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" sx={{ ml: 2, flex: 1 }}>
              {props.title}
            </Typography>

            <Button
              disabled={props.disabled ? props.disabled : false}
              autoFocus
              color="inherit"
              onClick={props.add ? props.add : props.save}
            >
              {t`save`}
            </Button>
          </Toolbar>
        </AppBar>

        {props.buildContent}
      </Dialog>
    </div>
  );
}
